import { useMemo } from 'react';

import { useNewUserAccessRights } from '@app/hooks/useNewUserAccessRights';

interface UseCalendarPermissionsResult {
  canAccessJournal: boolean;
  canCreateRecord: boolean;
  canShowContacts: boolean;
  canViewPastRecords: boolean;
}

export const useCalendarPermissions = (): UseCalendarPermissionsResult => {
  const {
    userAccessRights: {
      Clients: { IsShowContacts },
      Records: { IsCreate, IsJournal, IsOn, IsViewPastRecords },
    },
  } = useNewUserAccessRights();

  return useMemo(
    () => ({
      canAccessJournal: IsOn && IsJournal,
      canCreateRecord: IsCreate,
      canShowContacts: IsShowContacts,
      canViewPastRecords: IsViewPastRecords,
    }),
    [IsCreate, IsJournal, IsOn, IsShowContacts, IsViewPastRecords]
  );
};
